module.exports = __webpack_public_path__ + "cd84851405e7b94f6551e73253077780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin1.png
// module id = 1737
// module chunks = 24